export enum NotificationType {
  NEW_CHAT = 'NEW_CHAT',
  NEW_MESSAGE = 'NEW_MESSAGE',
  UPDATE_CHAT = 'UPDATE_CHAT',
  ARCHIVED_CHAT = 'ARCHIVED_CHAT',
  USER_AVAILABLE = 'USER_AVAILABLE'
}
